import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css";

const CoreServices = () => {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div className="about-section padding-container">
      <div className="page-wrapper">
        <div className="about-us">

          {/* Core Services */}
          <div className="about-1" data-aos="fade-up" data-aos-duration="1000">
            <h1>
              CORE SERVICE <span className="orange-text">HIGHLIGHTS</span>
            </h1>

            <p>
              <span className="orange-text">
                Expert digital services crafted to elevate your brand through{" "}
              </span>
              <span>
                design, development, marketing, and innovation.
              </span>
            </p>

            <br />

            <ul >
              <li>Graphic Design & Branding – Professional brand visuals and identity.</li>
              <li>UI/UX Design – User-focused, strategic interface design.</li>
              <li>Web & Frontend Development – Fast, responsive, and modern websites.</li>
              <li>FullStack Development – Complete web apps with backend, APIs & databases.</li>
              <li>Mobile App Development – Android, iOS & cross-platform apps.</li>
              <li>Motion Graphics & Animations – Engaging promo and explainer videos.</li>
              <li>SEO Services – On-page SEO, technical optimization & ranking growth.</li>
              <li>Digital Marketing – Social media campaigns, ads & brand growth.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CoreServices;
